import { UseQueryOptions } from '@tanstack/react-query';

import { CohortWithPatients } from 'domains/segments/types';
import { CuredApiPaths } from 'models/enums';

import useQuery from '../useQuery';

import QueryKeys from './keys';

const useSegmentCohort = (cohortId: string, reactQueryOptions?: UseQueryOptions<CohortWithPatients, Error>) =>
    useQuery<CohortWithPatients>(
        QueryKeys.SEGMENT_COHORT_ID(cohortId),
        `${CuredApiPaths.SEGMENTS}/cohorts/${cohortId}`,
        reactQueryOptions
    );

export default useSegmentCohort;
